import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  campaignsSelector,
  subventionPromo,
} from '~src/domains/common/state/commonSelectors';
import { showPromoBanner } from '~src/utils/helpers';
import * as styles from '~src/styles/domains/start/StartPage.module.scss';

const SubventionPromo: FunctionComponent = () => {
  const { t } = useTranslation();
  const campaigns = useSelector(campaignsSelector);
  const hasPromoConfig = useSelector(subventionPromo);
  const showPromo = showPromoBanner(hasPromoConfig, campaigns);

  if (!showPromo) return <></>;

  return (
    <div className={styles['subvention-promo']}>
      <div className={styles['promo-label']}>{t('start:subvention-promo')}</div>
    </div>
  );
};

export default SubventionPromo;
